import vi from './vi.json';

export function pseudoI18n() {
  return {
    t: (key: string) => vi[key] || key
  };
}
